import {connect} from 'react-redux';
import ModalSendPDFDraft from './ModalSendPDFDraft';
import {sendPDFDraft} from '../../../actions/steps/sendPDFDraft';
import {showGlobalErrorMessage} from '../../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {sendPDFDraft, showGlobalErrorMessage}
)(ModalSendPDFDraft);
